<template>
	<section class="container">
		<nav aria-label="breadcrumb" class="mt-3">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<router-link to="/" class="primary">Home</router-link>
				</li>
				<li
					class="breadcrumb-item active text-bold"
					style="color: #19bc9d;"
					aria-current="page"
				>
					Nasaha
				</li>
			</ol>
		</nav>

		<div v-if="nasahaContent">
			<h6
					class="mt3 text-left white bg-main pa2"
					style="word-spacing: 3px;letter-spacing: 2px;"
				>
				{{nasahaContent.title}}
			</h6>
			<div class="content text-left" v-html="nasahaContent.detail" v-if="nasahaContent.detail">
			</div>
			<div class="text-danger mt-5" v-else>
				No Content Found
			</div>
		</div>
		<vue-loaders
			class="siteLoader"
			name="line-scale"
			color="#19bc9d"
			scale=".9"
			v-if="isLoading"
		></vue-loaders>
	</section>
</template>
<script>
import axios from 'axios';
export default {
	data() {
		return {
			isLoading: false,
			cookieFound: false,
			loadScript: '',
			nasahaContent:null
		};
	},
	methods: {
		
	},
	created() {
	
		this.isLoading = true;
		const title_id = this.$route.params.id;
		let obj = {
			date:null,
			id:title_id
		}
		axios.post('nasaha',obj)
		.then((response) => {
			let result = response.data;
			if (result.status==201) {
				this.nasahaContent = result.data
				this.isLoading = false;
			}
		})
		.catch((error) => {
			alert(error)
			this.isLoading = false;
		});
	},
};
</script>
<style scoped>
.breadcrumb{
	position: relative;
	background: transparent;
	-webkit-box-shadow: 0px 5px 10px -17px brown;
	-moz-box-shadow: 0px 5px 10px -17px brown;
	-o-box-shadow: 0px 5px 20px -17px brown;
	box-shadow: 0px 5px 17px -17px brown;
}

.breadcrumb li {
	font-size: 13px;
	text-transform: uppercase;
	letter-spacing: 1px;
	word-spacing: 3px;
}
.breadcrumb li a {
	text-decoration: none;
}
.content{
	letter-spacing: 1px;
}
</style>
